import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"account-content"},[_c('div',{staticClass:"username"},[_c(VIcon,{staticClass:"user-icon"},[_vm._v("mdi-account-circle")]),_c('span',[_vm._v(_vm._s(_vm.username))])],1),_c('div',{staticClass:"user-status"},[_vm._v(_vm._s(_vm.userStatus))]),_c('div',{staticClass:"disconnect-button-box"},[_c(VBtn,{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.disconnect()}}},[_vm._v("Déconnexion")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }